var EVENTS = {
	TRACKING : "TRACKING",
	TRACKING_PAGE_EXTRA : "TRACKING_PAGE_EXTRA",
	TRACKING_PAGE : "TRACKING_PAGE", //RAW DISPATCH WITH OUR OWN TEXT DEFINING SECTION TO PROCESS ON TRACKINGJS
	TRACKING_CLICK : "TRACKING_CLICK",
	TRACKING_CLICKBUY : "TRACKING_CLICKBUY",
	TRACKING_VIDEO : "TRACKING_VIDEO",
	///////////////////////////////////////////////
	// ANIM TRIGGER EVENTS
	///////////////////////////////////////////////
	SAVEIMAGE_ANIM : "SAVEIMAGE_ANIM",
	///////////////////////////////////////////////
	// INPUT EVENTS
	///////////////////////////////////////////////
	INVALID_CHARACTER : "INVALID_CHARACTER",

	///////////////////////////////////////////////
	// RENDERER EVENTS
	///////////////////////////////////////////////
	UPDATE_OVERLAYANIM : "UPDATE_OVERLAYANIM",
	TOGGLE_RENDER : "TOGGLE_RENDER",
	
	///////////////////////////////////////////////

	///////////////////////////////////////////////
	//VISIBILITY EVENTS
	//////////////////////////////////////////////
	RESIZE : "RESIZE",
	VISIBILITY_CHANGE  : "VISIBILITY_CHANGE",

	///////////////////////////////////////////////
	//PAGE EVENTS
	//////////////////////////////////////////////
	PAGE_SWIPE_UP : "PAGE_SWIPE_UP",
	PAGE_SWIPE_DOWN : "PAGE_SWIPE_DOWN",
	PAGE_CLOSEING : "PAGE_CLOSEING", 		// when a page starts to close (passes closing page name)
	PAGE_CLOSED : "PAGE_CLOSED", 			// when a page has finished closing (passes closed page name)
	PAGE_OPENING : "PAGE_OPENING", 		// When a page begins to open (passes opening page name)
	PAGE_OPENED : "PAGE_OPENED", 			// When a page has finished opening (passes opened page name)
	
	///////////////////////////////////////////////
	//SHARING EVENTS
	//////////////////////////////////////////////
	
	SHARE_IMAGE : "SHARE_IMAGE",
	SHARE_IMAGE_READY : "SHARE_IMAGE_READY",
	SHARE_IMAGE_READY_FB : "SHARE_IMAGE_READY_FB",
	SHARE_IMAGE_FB_DONE : "SHARE_IMAGE_FB_DONE",
	SHARE_IMAGE_TW_DONE : "SHARE_IMAGE_TW_DONE",
	///////////////////////////////////////////////
	//MESSAGE3D EVENTS
	//////////////////////////////////////////////

	SHOW_MESSAGE_3D : "SHOW_MESSAGE_3D",
	HIDE_MESSAGE_3D : "HIDE_MESSAGE_3D",
	DESTROY_MESSAGE_3D : "DESTROY_MESSAGE_3D",
	CREATE_MESSAGE_3D : "CREATE_MESSAGE_3D",


	///////////////////////////////////////////////
	//SHOW EXPLORE HIDE EXPLORE USE TO SHOW AND HIDE HOTSPOTS
	//////////////////////////////////////////////

	SHOW_EXTRA_CONTENT : "SHOW_EXTRA_CONTENT", //show
	SHOW_EXTRA_CONTENTANIM : "SHOW_EXTRA_CONTENTANIM", //show ANIMATION OF OVERLAY
	SHOW_EXPLORE : "SHOW_EXPLORE",
	SHOW_SHARE : "SHOW_SHARE",
	HIDE_EXPLORE : "HIDE_EXPLORE",
	CLOSE_OVERLAY : "CLOSE_OVERLAY",

	///////////////////////////////////////////////
	//SOUND EVENTS
	//////////////////////////////////////////////
	CHARGE_SOUND_ON : "CHARGE_SOUND_ON",
	CHARGE_SOUND_OFF : "CHARGE_SOUND_OFF",
	TAB_SOUND : "TAB_SOUND",
	MUTE_SOUND : "MUTE_SOUND",
	UNMUTE_SOUND : "UNMUTE_SOUND"
};
